export enum ListViewSelectionMode {
  None = 1,
  DirectSelect = 2,
  SingleSelect = 3,
  MultiSelect = 4
}
